import {
  AppShell,
  BrandMark,
  type NavItem,
  SidebarVersion,
  UserMenu,
} from '@skylabs-digital/backoffice-kit';
import { routerNavItems } from '@skylabs-digital/backoffice-kit/router';
import { useAuthActions, useAuthState } from '@skylabs-digital/react-identity-access';
import {
  Activity,
  AlertTriangle,
  Clock3,
  KeyRound,
  LayoutDashboard,
  Mail,
  Plug,
  ScrollText,
  Settings,
  ShieldCheck,
  Users,
  Webhook,
} from 'lucide-react';
import { Outlet, useNavigate } from 'react-router-dom';
import { GlobalAppSelector } from '../components/GlobalAppSelector';
import { useVersion } from '../hooks/useVersion';

/**
 * Los items ya no se filtran por rol: en una superficie de plataforma no
 * habia dos niveles que distinguir, todo el que entro es un actor de
 * plataforma `(platform, admin)`. Cuando haga falta separar SUPERADMIN de
 * SUPPORT/AUDITOR eso sale de `context.role` y aplica tambien a las rutas,
 * no solo al menu (bead `idachu-ji8`).
 */
const NAV_ITEMS: NavItem[] = [
  {
    label: 'Dashboard',
    to: '/',
    icon: <LayoutDashboard className="h-5 w-5" />,
    section: 'Overview',
  },
  { label: 'Metrics', to: '/metrics', icon: <Activity className="h-5 w-5" />, section: 'Overview' },

  {
    label: 'Notifications',
    to: '/notifications',
    icon: <Mail className="h-5 w-5" />,
    section: 'Messaging',
  },
  {
    label: 'Templates',
    to: '/templates',
    icon: <ScrollText className="h-5 w-5" />,
    section: 'Messaging',
  },
  { label: 'DLQ', to: '/dlq', icon: <AlertTriangle className="h-5 w-5" />, section: 'Messaging' },
  {
    label: 'Webhooks',
    to: '/webhooks',
    icon: <Webhook className="h-5 w-5" />,
    section: 'Messaging',
  },

  { label: 'Apps', to: '/apps', icon: <Settings className="h-5 w-5" />, section: 'Configuration' },
  {
    label: 'Preferences',
    to: '/preferences',
    icon: <ShieldCheck className="h-5 w-5" />,
    section: 'Configuration',
  },
  {
    label: 'Providers',
    to: '/providers',
    icon: <Plug className="h-5 w-5" />,
    section: 'Configuration',
  },
  {
    label: 'Rate Limits',
    to: '/rate-limits',
    icon: <Clock3 className="h-5 w-5" />,
    section: 'Configuration',
  },

  { label: 'Users', to: '/users', icon: <Users className="h-5 w-5" />, section: 'System' },
  { label: 'API Keys', to: '/api-keys', icon: <KeyRound className="h-5 w-5" />, section: 'System' },
];

export function AppLayout() {
  const { user, context } = useAuthState();
  const { logout } = useAuthActions();
  const navigate = useNavigate();
  const version = useVersion();

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate('/login', { replace: true });
    }
  };

  return (
    <AppShell
      brand={<BrandMark initials="n" title="noten" subtitle="Backoffice" />}
      navItems={routerNavItems(NAV_ITEMS)}
      headerRight={
        <div className="flex items-center gap-3">
          <GlobalAppSelector />
          <UserMenu user={user ?? undefined} subtitle={context?.role} onSignOut={handleLogout} />
        </div>
      }
      sidebarFooter={<SidebarVersion name="noten" version={version} />}
    >
      <Outlet />
    </AppShell>
  );
}
